// @flow weak

import React, {
  PureComponent
}                     from 'react';
import PropTypes      from 'prop-types';
import {
  Row,
  Col,
  Button
}                     from 'react-bootstrap';
import { withRouter }         from 'react-router';
import { connect }            from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions           from '../../redux/modules/actions';
// import AnimatedView   from '../../components/animatedView/AnimatedView';
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../services/fetchTools';


function fakeLogin({ username }) {
  return new Promise(
    resolve => {
      setTimeout(
        () => resolve({ token: '1234567890123456', username }),
        200
      );
    }
  );
}

class Login extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      country_code: 91,
      };
    this.handleSubmit = this.handleSubmit.bind(this);
    
  }
  static propTypes= {
    // react-router 4:
    match:    PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    history:  PropTypes.object.isRequired,

    // views props:
    currentView: PropTypes.string.isRequired,

  };

  state = {
    email:          '',
    password:       '',
    isAuthenticating: false
  };

  componentDidMount() {
    const { actions: { enterPage } } = this.props;
    enterPage('Login');
  }

  componentWillUnmount() {
    const { actions: { leavePage } } = this.props;
    leavePage('Login');
  }

  render() {
    const {
      email,
      password,
      isAuthenticating
    } = this.state;

    const{ user,history,isFetching, userInfos } = this.props;
    const {locationMenu} = this.props;

    console.log(user);

    if(isFetching != isAuthenticating){
      this.setState({ isAuthenticating: isFetching });      
    }

    if(user.data.isAuthenticated==true || user.data.isAuthenticated=='true'){
      localStorage.setItem('isAuthenticated', user.data.isAuthenticated);
      if(locationMenu.access_config != 'Technichal Partner'){
        history.push({ pathname: '/' }); // back to Home 
      }
      else{
        history.push({ pathname: '/partnerBFC' }); 
      }
           
      return null;
    }
    console.log(locationMenu);

    return (
      <div className="content">
        <Row style={{margin:'0'}}>
          <Col
            md={4}
            mdOffset={4}
          >
            <form
              className="form-horizontal"
              noValidate>
              <fieldset>
                <legend>
                  Login
                </legend>

                <div className="form-group">
                  <label
                    htmlFor="inputEmail"
                    className="col-lg-2 control-label">
                    Mobile
                  </label>
                  <div className="col-lg-10" style={{display:'flex',gap:'10px'}}>
                    <select value={this.state.country_code} onChange={(e)=>this.setState({country_code: e.target.value})} className="form-control" style={{width:'fit-content'}}>
                      <option value={91}>+91</option>
                      <option value={971}>+971</option>
                      <option value={974}>+974</option>
                    </select>
                    <input
                      type="number"
                      className="form-control"
                      id="inputEmail"
                      placeholder="Mobile Number"
                      value={email}
                      onChange={this.handlesOnEmailChange}
                    />
                  </div>
                </div>
                <div className="col-lg-12 col-xs-12" style={{marginTop: '5px',display:'flex',justifyContent:'end'}}>
                <button className="btn btn-default" style={{backgroundColor: '#4697cd', padding: '1%', borderColor: '#4697cd', borderWidth: '2px', width: '380px', alignSelf: 'center'}}
                type="button" onClick={this.handleSubmit}><span style={{color: '#ffffff'}}>Submit</span></button>
                                  
               </div>
               {
                this.state.validate ?
                <div style={{marginTop: '70px'}}>
                 <div className="form-group">
                  <label
                    htmlFor="inputPassword"
                    className="col-lg-2 control-label">
                    OTP
                  </label>
                  <div className="col-lg-10">
                    <input
                      type="password"
                      className="form-control"
                      id="inputPassword"
                      placeholder="otp"
                      value={password}
                      onChange={this.handlesOnPasswordChange}
                    />
                  </div>
                </div>
                <div className="form-group">
                  <Col
                    lg={10}
                    lgOffset={2}
                  >
                    <Button
                      className="login-button btn-block"
                      bsStyle="primary"
                      disabled={isAuthenticating}
                      onClick={this.handlesOnLogin}>
                      {
                        isAuthenticating
                          ?
                          <span>
                            login in...
                            &nbsp;
                            <i
                              className="fa fa-spinner fa-pulse fa-fw"
                            />
                          </span>
                          :
                          <span>
                            Login
                          </span>
                      }
                    </Button>
                  </Col>
                </div>
               </div> 
                :
                <div>
                </div>

               }
                <div className="form-group error">
                  <span>{user.data.error_message}</span>
                </div>                
              </fieldset>
            </form>
          </Col>
        </Row>
      </div>
    );
  }
  postMobile(mobile_no){
    const url = `${getLocationOrigin()}/auth/verify_mobile_start`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'}
    options['body'] = JSON.stringify({
                        'mobile_no': mobile_no,
                        'country_code': this.state.country_code,
                      });
    console.log('Going to fetch');
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then(response => this.setState({ validate: response.authentication}))
      .catch(error => {
        console.log(error);
        alert(error.message);
      });

  }
  handleSubmit(event){
    this.postMobile(this.state.email);

  }

  handlesOnEmailChange = (event) => {
    event.preventDefault();
    // should add some validator before setState in real use cases
    this.setState({ email: event.target.value.trim() });
  }

  handlesOnPasswordChange = (event) => {
    event.preventDefault();
    // should add some validator before setState in real use cases
    this.setState({ password: event.target.value.trim() });
  }

  handlesOnLogin = async (event) => {
    event.preventDefault();
    const {
      history
    } = this.props;

    const {
      email,
      password
    } = this.state;

    const user = {
      username: email,
      password: password
    };

    this.setState({ isAuthenticating: true });

    const { actions: { loginUser } } = this.props;    
    loginUser(email,password,'venue_portal');
    {/*
    try {
      await fakeLogin(user);
      this.setState({ isAuthenticating: false });
      history.push({ pathname: '/' }); // back to Home
    } catch (error) {

      this.setState({ isAuthenticating: false });
      console.log('login went wrong..., error: ', error);

    }
    */}
  }
}

const mapStateToProps = (state) => {
  return {
    userInfos:           state.userInfos.data,
    user:                state.user,
    locationMenu:        state.locationMenu
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions : bindActionCreators(
      {...actions},
      dispatch)
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Login)
);



// WEBPACK FOOTER //
// ./src/app/views/login/Login.js